import { getQueryWithParams, getQuery, } from "src/components/ApolloConnection/ApolloProviderComponent";
import { LIST_PATIENT_RECORDS } from "src/components/graphql/GraphQLquery";
import { snackbar } from "@mobiscroll/react5";

export async function listPatients(displayRecords, search) {
  try {
    const take = displayRecords > 0 ? displayRecords : 10;
    const response = await getQuery(LIST_PATIENT_RECORDS(200, search));

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch patients");
    }

    const patientData = response?.data?.listDoctorPatients;

    // Check for error response (statusCode >= 400)
    if (patientData?.statusCode && patientData.statusCode >= 400) {
      throw new Error(patientData?.message || "Failed to fetch patients");
    }

    // Success case - either no statusCode (old APIs) or statusCode 200-299
    const records = patientData?.data || [];

    if (records.length > 0) {
      snackbar({
        message: patientData?.message || "Patient list fetched successfully.",
        color: "success"
      });
    }

    return patientData || { data: [], total: 0 };
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger"
    });
    console.error("Error at listPatients:", e);
    return { data: [], total: 0 };
  }
}

export async function getPatientBasicDetails(data) {
  try {
    const response = await getQueryWithParams(LIST_PATIENT_RECORDS, data);

    if (!response || response.errors) {
      throw new Error(response?.errors?.[0]?.message || "Failed to fetch patients");
    }

    const result = response?.data?.listDoctorPatients;

    // Check for error response (statusCode >= 400)
    if (result?.statusCode && result.statusCode >= 400) {
      throw new Error(result?.message || "Failed to fetch patients");
    }

    // Success case
    if (result?.data && result.data.length > 0) {
      snackbar({
        message: result?.message || "Patient list fetched successfully.",
        color: "success",
      });
      return result.data;
    }
    return [];
  } catch (e) {
    snackbar({
      message: e.message,
      color: "danger",
    });
    console.error("Error at getPatientBasicDetails:", e);
    return [];
  }
}
